import AdminTemplate from './AdminTemplate';
export default AdminTemplate;
